import {useQuery} from '@tanstack/react-query';
import fetcher from 'src/utils/fetcher';

const getPlaceQuery = (countryCode: string | undefined, placeNameId: string | undefined) => ({
  url: '/api/places/find',
  query: {countryCode, placeNameId, includeMyReview: true}
});

const usePlace = (countryCode: string | undefined, placeNameId: string | undefined) => {
  const placeQuery = getPlaceQuery(countryCode, placeNameId);

  const {
    data: place = null,
    refetch: refetchPlace,
    isLoading
  } = useQuery({
    queryKey: ['place', countryCode, placeNameId],
    queryFn: () => fetcher<Place>(placeQuery),
    staleTime: 3000,
    enabled: Boolean(countryCode && placeNameId)
  });

  return {place, refetchPlace, isPlaceLoading: isLoading};
};

export default usePlace;
